import { InputAdornment, TextField, TextFieldProps } from '@mui/material';

import { Checkmark, ExclamationMarkRed } from '@nuuday/yousee-dna/generated/icons/forms';

import React, { forwardRef, useState } from 'react';

type TextFieldWithValidationIconProps = {
  maxLength?: number;
} & TextFieldProps;

const TextFieldWithValidationIcon = forwardRef<HTMLDivElement, TextFieldWithValidationIconProps>(
  (props: TextFieldWithValidationIconProps, ref) => {
    const { error, onBlur, maxLength } = props;

    const [touched, setTouched] = useState(false);

    return (
      <TextField
        {...props}
        ref={ref}
        fullWidth
        hiddenLabel
        inputProps={{
          maxLength,
          'data-hj-suppress': '',
        }}
        onBlur={(event) => {
          setTouched(true);
          if (onBlur) {
            onBlur(event);
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              {error ? (
                <ExclamationMarkRed width='24' height='24' />
              ) : (
                touched && <Checkmark width='24' height='24' />
              )}
            </InputAdornment>
          ),
        }}
      />
    );
  },
);

TextFieldWithValidationIcon.displayName = 'TextFieldWithValidationIcon';
export default TextFieldWithValidationIcon;
